<template>
    <div>
        <!-- 搜索栏 -->
        <el-form  :inline="true"  :model="form" class="demo-form-inline">
            <el-form-item label="手机号">
                <el-input v-model="form.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="会员ID">
                <el-input v-model="form.uid" placeholder="会员ID"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryUser">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table
            :data="tableData"    style="width: 100%"
            :row-class-name="tableRowClassName">
            <el-table-column
                prop="id"
                label="客户id"
                width="120">
            </el-table-column>
            <el-table-column>
                <template #default="{ row }">
                                       <el-avatar v-if="row.avatar" shape="square" :size="50" :src="row.avatar"></el-avatar>
                </template>
            </el-table-column>
            <el-table-column
                prop="nickname"
                label="昵称"
                width="180">
            </el-table-column>
            <el-table-column
                prop="grade_name"
                label="等级">
            </el-table-column>
            <el-table-column
                label="操作"
                width="120">
                <template #default="{ row }">
                    <el-button
                        size="small"
                        type="success"
                        @click="handleSelect(row)">
                        选中
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import {request} from "@/common/request";

export default {

    data() {
        return {
            form: {
                phone: "",
                uid: ""
            },
            tableData: []
        };
    },
    methods: {
        queryUser() {

            let url = '/account/list';
            let params = {
                phone: this.form.phone,
                uid: this.form.uid,
                page: 1,
                pagesize: 5
            }
            console.log(params)
            request.get(url, params).then(ret => {
                if (ret.code == 1) {
                    this.tableData = ret.data.list;
                    console.log(ret)
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 1) {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            }
            return '';
        },
        handleSelect(row) {
            this.$emit('select-user', row); // 向父组件传递选中的 当前用户
        }
    }
};
</script>

<style>.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>